module.exports = __webpack_public_path__ + "static/media/54.eb1c46e3.png";